import { render, staticRenderFns } from "./MultipleAnswerMatrix.vue?vue&type=template&id=0adc18b3&"
import script from "./MultipleAnswerMatrix.vue?vue&type=script&lang=js&"
export * from "./MultipleAnswerMatrix.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAnswerMatrix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports